const FOCUS_HINTS_EN = [
  'digital',
  'solutions',
  'tomorrow',
  'software',
  'company',
  'logo',
  'icon',
  'mark',
  'brand',
  'text',
  'title',
  'headline',
  'tagline',
  'veralyon',
];

const FOCUS_HINTS_KA = [
  'ციფრული',
  'გადაწყვეტილება',
  'ხვალ',
  'დღეს',
  'კომპანია',
  'პროგრამ',
  'logo',
  'icon',
  'mark',
  'brand',
  'text',
  'title',
  'headline',
  'tagline',
  'veralyon',
];

const EXCLUDE_HINTS = [
  'line',
  'wave',
  'curve',
  'path',
  'grid',
  'terrain',
  'wire',
  'flow',
  'tube',
  'spline',
];

export const FOCUS_ZOOM_AMOUNT =
  Number(process.env.REACT_APP_SPLINE_FOCUS_ZOOM) || 0.08;

const getNavHeightPx = () => {
  const value = getComputedStyle(document.documentElement).getPropertyValue(
    '--nav-height'
  );
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 70;
};

/** 0 = top of page (zoom in), 1 = hero scrolled away */
export const getHeroScrollProgress = (heroEl) => {
  if (!heroEl) return 0;

  const navPx = getNavHeightPx();
  const heroHeight = heroEl.offsetHeight;
  if (heroHeight <= 0) return 0;

  const top = heroEl.getBoundingClientRect().top - navPx;
  return Math.min(Math.max(-top / heroHeight, 0), 1);
};

const isKaLocale = (language) =>
  (language || 'en').split('-')[0].toLowerCase() === 'ka';

const getFocusHints = (language) =>
  isKaLocale(language) ? FOCUS_HINTS_KA : FOCUS_HINTS_EN;

export const findFocusObjects = (app, language = 'en') => {
  const fromEnv = isKaLocale(language)
    ? process.env.REACT_APP_SPLINE_FOCUS_OBJECTS_KA
    : process.env.REACT_APP_SPLINE_FOCUS_OBJECTS;

  if (fromEnv) {
    return fromEnv
      .split(',')
      .map((name) => name.trim())
      .filter(Boolean)
      .map((name) => app.findObjectByName?.(name))
      .filter(Boolean)
      .map((obj) => ({
        obj,
        base: { x: obj.scale.x, y: obj.scale.y, z: obj.scale.z },
      }));
  }

  return (app.getAllObjects?.() || [])
    .filter((obj) => {
      const name = obj.name?.toLowerCase() ?? '';
      if (EXCLUDE_HINTS.some((hint) => name.includes(hint))) return false;
      const hints = getFocusHints(language);
      return hints.some((hint) => name.includes(hint.toLowerCase()));
    })
    .map((obj) => ({
      obj,
      base: { x: obj.scale.x, y: obj.scale.y, z: obj.scale.z },
    }));
};

export const applyFocusZoom = (targets, progress) => {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const focusAmount = isMobile ? 0 : FOCUS_ZOOM_AMOUNT;
  const zoom = 1 + (1 - progress) * focusAmount;

  targets.forEach(({ obj, base }) => {
    obj.scale.x = base.x * zoom;
    obj.scale.y = base.y * zoom;
    obj.scale.z = base.z * zoom;
  });
};
